module.exports = __webpack_public_path__ + "2a9df00fd8bad22b9aae43d3d1814998.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PartLogo.png
// module id = 1079
// module chunks = 0